import { QueryClient } from '@tanstack/react-query';
import { trackError } from './errorMonitoring';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 10 * 60 * 1000, // 10 minutes
            staleTime: 5 * 60 * 1000, // 5 minutes
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            retry: (failureCount, error) => {
                if (error.response?.status === 401) {
                    return false;
                }

                const defaultRetry = new QueryClient().getDefaultOptions().queries?.retry;

                return Number.isSafeInteger(defaultRetry) ? failureCount < (defaultRetry ?? 0) : false;
            },
        },
        onError: (error) => {
            // 401 is handled centrally in axiosInstance (token cleared + page reload).
            if (error.response?.status === 401) return;
            trackError(error);
        },
    },
});

export default queryClient;
